import { TECH_STACK_DATA } from '../../constants';
import { useLanguage } from '../../hooks/useLanguage';
import '../../styles/components/Partners.css';

const Partners = () => {
  const { t } = useLanguage();

  return (
    <section id='partners' className='partners section'>
      <div className='container'>
        <div className='partners-header'>
          <h2 className='partners-title'>{t.partners.sectionTitle}</h2>
          <p className='partners-subtitle'>{t.partners.sectionSubtitle}</p>
        </div>

        <div className='partners-grid'>
          {TECH_STACK_DATA.map(tech => (
            <div key={tech.id} className='partner-item'>
              <span className='partner-name'>{tech.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Partners;
